<div class="review-cont">



    <div class="container">
        <h1>
            {{ data.title }}
        </h1>

        <!-- Desktop: 3 columns -->
        <div class=" row g-4" *ngIf="!isMobile">
            <div class="col-md-4" *ngFor="let item of data.services">
                <div class="review-card">
                    <div class="stars">
                        <ng-container *ngFor="let s of [1,2,3,4,5]">
                            <span class="star" [class.filled]="s <= item.rating">★</span>
                        </ng-container>
                    </div>
                    <p class="review-text">{{ item.review }}</p>
                    <div class="reviewer">

                        <div>
                            <div class="reviewer-name">{{ item.name }}</div>
                            <div class="reviewer-role"> {{item.courseTr}}</div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Mobile: carousel -->
        <div class="mobile-carousel-wrapper" *ngIf="isMobile">
            <div class="carousel-viewport">
                <div class="carousel-track" #carouselTrack (touchstart)="onTouchStart($event)"
                    (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd($event)">
                    <div class="carousel-slide" *ngFor="let item of data.services">
                        <div class="review-card">
                            <div class="stars">
                                <ng-container *ngFor="let s of [1,2,3,4,5]">
                                    <span class="star" [class.filled]="s <= item.rating">★</span>
                                </ng-container>
                            </div>
                            <p class="review-text">{{ item.review }}</p>
                            <div class="reviewer">

                                <div>
                                    <div class="reviewer-name">{{ item.name }}</div>
                                    <div class="reviewer-role">طالب/ة أسرار كتابة الهمزة</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="carousel-dots">
                <span class="dot" *ngFor="let item of data.services; let i = index" [class.active]="i === activeIndex"
                    (click)="goToSlide(i)"></span>
            </div>
        </div>
    </div>
</div>